import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { Color, MAX_WIDTH } from 'views/constants';
import { Spacer } from 'views/components/atoms/Spacer';
import { AppLinkList } from 'views/components/organisms/AppLinkList';
import { Button } from 'views/components/atoms/Button';
import { Driver } from 'views/components/atoms/Driver';
import { localeIds } from 'locals';
import { AppDetail } from 'views/components/organisms/AppDetail';
import { Application } from 'models/Application/type';
import { AvailableApplication, DeviceDetail } from 'models/Device/type';
import { Icon } from 'views/components/molecules/Icon';
import { Typography } from 'views/components/atoms/Typography';

const Wrapper = styled.div`
  text-align: initial;
  padding-bottom: 28px;
`;

const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  width: ${MAX_WIDTH};
`;

const ButtonWrapper = styled.div`
  max-width: ${MAX_WIDTH};
  margin: auto;
`;

type AppDetailLayoutProps = {
  deviceDetail: DeviceDetail;
  application: Application;
  otherApplications: AvailableApplication[];
  existOtherVersion?: boolean;
  startInstall?: boolean;
  startOverwriteInstall?: boolean;
  onInstall(): void;
  onOverwriteInstall(): void;
  onUnsupportedOverwriteInstall(): void;
  onShowOtherVersion(): void;
  installReady: boolean;
  onReInstallProfile(): void;
  onClickSearch(): void;
};

export const AppDetailPageLayout: React.FC<AppDetailLayoutProps> = ({
  deviceDetail,
  application,
  otherApplications,
  existOtherVersion = false,
  startInstall,
  startOverwriteInstall,
  onInstall,
  onOverwriteInstall,
  onUnsupportedOverwriteInstall,
  onShowOtherVersion,
  installReady,
  onReInstallProfile,
  onClickSearch,
}) => (
  <Wrapper>
    <AppDetail
      deviceDetail={deviceDetail}
      application={application}
      startInstall={startInstall}
      startOverwriteInstall={startOverwriteInstall}
      onInstall={onInstall}
      onOverwriteInstall={onOverwriteInstall}
      onUnsupportedOverwriteInstall={onUnsupportedOverwriteInstall}
      installReady={installReady}
      onReInstallProfile={onReInstallProfile}
    />
    <Spacer />
    <Driver />

    {otherApplications.length > 0 ? (
      <>
        <Spacer size="large" />

        <SearchWrapper>
          <Typography bold color={Color.C3}>
            <FormattedMessage
              id={localeIds.appDetailPageLayout.otherVersions}
            />
          </Typography>
          <Icon type="search" size="default" onClick={onClickSearch} />
        </SearchWrapper>

        <Spacer />
        <Driver />

        <AppLinkList applications={otherApplications} distributions={[]} />
        <Driver />
        <Spacer />

        {existOtherVersion ? (
          <ButtonWrapper>
            <Button type="button" onClick={onShowOtherVersion}>
              <FormattedMessage
                id={localeIds.appDetailPageLayout.showOtherVersions}
              />
            </Button>
          </ButtonWrapper>
        ) : null}
      </>
    ) : null}
  </Wrapper>
);
